import React from 'react';
import { GtmContext } from './GtmContext';
import { Gtm } from './hooks';
export const GtmProvider = ({ children }) => {
    const { sendEvent } = Gtm();
    return React.createElement(GtmContext.Provider, { value: { sendEvent } }, children);
};
